<template>
    <div class="canvas-wrapper">
        <div class="canvas-holder" id="canvasHolder">
            <canvas id="areasCanvas"></canvas>
        </div>
    </div>
</template>

<script>
    import Area from "../../classes/models/Area";

    export default {
        name: 'tests-areas-canvas',
        props: {
            testAreas: Array,
            maxAreas: Number

        },
        data() {
            return {
                vueCanvas: null,
                areas: []
            }
        },
        mounted() {
            this.buildCanvas();
        },
        methods: {
            buildCanvas() {
                let canvas = document.getElementById('areasCanvas'),
                    wrapper = document.getElementById('canvasHolder'),
                    ctx = canvas.getContext('2d'),
                    mouseX,
                    mouseY,
                    closeEnough = 5,
                    canvasOffset = canvas.getBoundingClientRect(),
                    clickedMousePositions = {
                        x: null,
                        y: null
                    },
                    image = new Image();

                image.src = this.$parent.$parent.test.image_url;
                image.onload = () => {
                    let imageRatio = image.height / image.width;
                    canvas.style.width = '100%';
                    canvas.width = canvas.offsetWidth;
                    canvas.height = (parseInt(canvas.width) * imageRatio);
                    canvas.style.background = "url('" + this.$parent.$parent.test.image_url + "') no-repeat";
                    canvas.style['background-size'] = 'contain';
                    init();
                    this.areas = _.map(this.testAreas, area => {
                        area.canvas = _.pick(canvas, ['width', 'height']);
                        const areaObject = new Area(area);
                        draw(areaObject);
                        return areaObject;
                    });
                };


                function init() {
                    canvas.addEventListener('mousedown', mouseDown, false);
                    canvas.addEventListener('mouseup', mouseUp, false);
                    canvas.addEventListener('mousemove', mouseMove, false);
                }


                function checkDeleteEnough(p1, p2) {
                    return Math.abs(p1 - p2) < closeEnough;
                }

                function checkTL(rect) {
                    return checkDeleteEnough(mouseX, rect.startX) && checkDeleteEnough(mouseY, rect.startY)
                }

                function checkTR(rect) {
                    return checkDeleteEnough(mouseX, rect.startX + rect.w) && checkDeleteEnough(mouseY, rect.startY);
                }

                function checkBL(rect) {
                    return checkDeleteEnough(mouseX, rect.startX) && checkDeleteEnough(mouseY, rect.startY + rect.h);
                }

                function checkBR(rect) {
                    return checkDeleteEnough(mouseX, rect.startX + rect.w) && checkDeleteEnough(mouseY, rect.startY + rect.h);
                }

                function checkInside(rect) {
                    return Math.abs((rect.startX + rect.w) - mouseX) < Math.abs(rect.w) &&
                        Math.abs((rect.startX) - mouseX) < Math.abs(rect.w) &&
                        Math.abs((rect.startY + rect.h) - mouseY) < Math.abs(rect.h) &&
                        Math.abs((rect.startY) - mouseY) < Math.abs(rect.h);
                }

                function checkDeleteButton(rect) {
                    return Math.abs((rect.deleteButton.startX + rect.deleteButton.w) - mouseX) < Math.abs(rect.deleteButton.w) &&
                        Math.abs((rect.deleteButton.startX) - mouseX) < Math.abs(rect.deleteButton.w) &&
                        Math.abs((rect.deleteButton.startY + rect.deleteButton.h) - mouseY) < Math.abs(rect.deleteButton.h) &&
                        Math.abs((rect.deleteButton.startY) - mouseY) < Math.abs(rect.deleteButton.h);
                }

                let checkCursor = () => {
                        let someoneIsBeingDragged = _.some(this.areas, area => area.drag);
                        canvas.style['cursor'] = someoneIsBeingDragged ? canvas.style['cursor'] : 'unset';
                        _.each(this.areas, rect => {
                            switch (true) {
                                case someoneIsBeingDragged:
                                    break;
                                case checkInside(rect):
                                    canvas.style['cursor'] = 'grab';
                                    break;
                                case checkTL(rect):
                                case checkBR(rect):
                                    canvas.style['cursor'] = 'nwse-resize';
                                    break;
                                case checkBL(rect):
                                case checkTR(rect):
                                    canvas.style['cursor'] = 'nesw-resize';
                                    break;
                                case checkDeleteButton(rect):
                                    canvas.style['cursor'] = 'pointer';
                                    break;
                            }
                        });
                    },
                    deleteRect = (rect) => {
                        this.areas = _.filter(this.areas, area => area.uuid !== rect.uuid);
                    },
                    mouseDown = e => {
                        mouseX = e.pageX - canvasOffset.left;
                        mouseY = e.pageY - (canvasOffset.top - wrapper.scrollTop);

                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        let caught = false;
                        _.each(this.areas, rect => {
                            draw(rect);
                            if (caught) {
                                return;
                            }
                            rect.dragTL = checkTL(rect);
                            rect.dragTR = checkTR(rect);
                            rect.dragBL = checkBL(rect);
                            rect.dragBR = checkBR(rect);
                            if (checkInside(rect, mouseX, mouseY)) {
                                rect.drag = true;
                                canvas.style['cursor'] = 'grabbing';
                                clickedMousePositions = {
                                    x: mouseX,
                                    y: mouseY
                                }

                            }
                            caught = rect.isCaught();

                            if (!rect.isCaught() && checkDeleteButton(rect)) {
                                caught = true;
                                deleteRect(rect);
                            }
                        });

                        if (!caught && this.areas.length < this.maxAreas) {
                            let newArea = new Area({
                                dragBR: true,
                                startX: mouseX,
                                startY: mouseY,
                                canvas: _.pick(canvas, ['width', 'height'])
                            });
                            this.areas.push(newArea);
                            draw(newArea);
                        }


                    },
                    mouseUp = () => {
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        _.each(this.areas, rect => {
                            rect.stop();
                            draw(rect, true);
                        });
                        checkCursor();
                    },
                    mouseMove = (e) => {
                        mouseX = e.pageX - canvasOffset.left;
                        mouseY = e.pageY - (canvasOffset.top - wrapper.scrollTop);
                        if (mouseY < 1 || mouseX < 1) {
                            return;
                        }
                        ctx.clearRect(0, 0, canvas.width, canvas.height);
                        _.each(this.areas, rect => {

                            switch (true) {
                                case rect.dragTL:
                                    rect.w += rect.startX - mouseX;
                                    rect.h += rect.startY - mouseY;
                                    rect.startX = mouseX;
                                    rect.startY = mouseY;
                                    break;
                                case rect.dragTR:
                                    rect.w = Math.abs(rect.startX - mouseX);
                                    rect.h += rect.startY - mouseY;
                                    rect.startY = mouseY;
                                    if ((mouseX - rect.startX) < 0) {
                                        rect.startX = mouseX;
                                        rect.dragTR = false;
                                        rect.dragTL = true;
                                    }
                                    if ((mouseY - rect.startY) < 0) {
                                        rect.startY = mouseY;
                                        rect.dragTR = false;
                                        rect.dragBR = true;
                                    }
                                    break;
                                case rect.dragBL:
                                    rect.w += rect.startX - mouseX;
                                    rect.h = Math.abs(rect.startY - mouseY);
                                    rect.startX = mouseX;
                                    if ((mouseY - rect.startY) < 0) {
                                        rect.startY = mouseY;
                                        rect.dragBL = false;
                                        rect.dragTL = true;
                                    }
                                    break;
                                case rect.dragBR:
                                    rect.w = Math.abs(rect.startX - mouseX);
                                    rect.h = Math.abs(rect.startY - mouseY);
                                    if ((mouseY - rect.startY) < 0) {
                                        rect.startY = mouseY;
                                        rect.dragBR = false;
                                        rect.dragTR = true;
                                    }
                                    if ((mouseX - rect.startX) < 0) {
                                        rect.startX = mouseX;
                                        rect.dragBR = false;
                                        rect.dragBL = true;
                                    }
                                    break;
                                case rect.drag:
                                    let xMove = mouseX - clickedMousePositions.x,
                                        yMove = mouseY - clickedMousePositions.y;
                                    rect.startX = rect.startX + xMove;
                                    rect.startY = rect.startY + yMove;
                                    clickedMousePositions = {
                                        x: mouseX,
                                        y: mouseY
                                    };
                                    break;
                            }

                            draw(rect);
                        });

                        checkCursor();

                    };

                function draw(rect, checkForMirror = false) {

                    // [Nick] Keep Area inside canvas
                    if (rect.startX < 0) {
                        rect.startX = 0;
                    }
                    if (rect.startX + rect.w >= canvas.width) {
                        rect.startX = canvas.width - rect.w;
                    }
                    if (rect.startY < 0) {
                        rect.startY = 0;
                    }
                    if (rect.startY + rect.h >= canvas.height) {
                        rect.startY = canvas.height - rect.h;
                    }


                    // [Nick] Fixing start positions if Area was mirrored
                    if (checkForMirror && rect.w < 0) {
                        rect.w = rect.w * -1;
                        rect.startX = rect.startX - rect.w;
                    }

                    if (checkForMirror && rect.h < 0) {
                        rect.h = rect.h * -1;
                        rect.startY = rect.startY - rect.h;
                    }

                    // [Nick] 2 borders, black and white, to make Area visible with any background color
                    ctx.strokeStyle = 'black';
                    ctx.lineWidth = 2;
                    ctx.strokeRect(rect.startX, rect.startY, rect.w, rect.h);
                    ctx.strokeStyle = 'lightgreen';
                    ctx.lineWidth = 2;
                    ctx.strokeRect(rect.startX + 2, rect.startY + 2, rect.w - 4, rect.h - 4);
                    drawHandles(rect);
                }

                function drawCircle(x, y, radius) {
                    ctx.beginPath();
                    ctx.arc(x, y, radius, 0, 2 * Math.PI);
                    ctx.stroke();
                }

                function drawSquare(x, y, size) {
                    ctx.strokeStyle = 'black';
                    ctx.lineWidth = 2;
                    ctx.strokeRect(x - size, y - size, size * 2, size * 2);
                    ctx.strokeStyle = 'white';
                    ctx.lineWidth = 2;
                    ctx.strokeRect(x - size + 2, y - size + 2, size * 2 - 4, size * 2 - 4);
                }

                function drawHandles(rect) {
                    drawSquare(rect.startX, rect.startY, closeEnough);
                    drawSquare(rect.startX + rect.w, rect.startY, closeEnough);
                    drawSquare(rect.startX + rect.w, rect.startY + rect.h, closeEnough);
                    drawSquare(rect.startX, rect.startY + rect.h, closeEnough);
                    if (!rect.isCaught()) {
                        drawDeleteButton(rect);
                        drawLabel(rect);
                    }
                }

                function drawDeleteButton(rect) {
                    ctx.fillStyle = 'black';
                    rect.deleteButton.startX = rect.startX + rect.w;
                    rect.deleteButton.startY = rect.startY + 5;
                    if ((rect.deleteButton.startX + rect.deleteButton.w) >= canvas.width) {
                        rect.deleteButton.startX = rect.startX - rect.deleteButton.w;
                    }
                    ctx.fillRect(rect.deleteButton.startX, rect.deleteButton.startY, rect.deleteButton.w, rect.deleteButton.h);
                    ctx.font = '600 15px/18px "Poppins", sans-serif';
                    ctx.fillStyle = 'white';
                    ctx.textAlign = 'center';
                    ctx.fillText('X', rect.deleteButton.startX + 10, rect.deleteButton.startY + 15);
                }

                function drawLabel(rect) {
                    if (!rect.label) {
                        return;
                    }
                    ctx.fillStyle = 'black';
                    const label = {
                        startX: rect.startX + 10,
                        startY: rect.startY - 20,
                        h: 20,
                        w: 60
                    };
                    if (rect.startY < label.h) {
                        label.startY = rect.startY + rect.h;
                    }
                    ctx.fillRect(label.startX, label.startY, label.w, label.h);
                    ctx.font = '600 12px/18px "Poppins", sans-serif';
                    ctx.fillStyle = 'white';
                    ctx.textAlign = 'center';
                    ctx.fillText(rect.label, label.startX + 30, label.startY + 15);
                }
            }
        },
        watch: {
            '$parent.$parent.test.id': {
                handler() {
                    this.buildCanvas();

                }
            },
            'areas.length': {
                deep: false,
                handler() {
                    _.each(this.areas, (area, i) => area.label = this.$t('tests.area', {i:i + 1}));
                    this.$emit('input', this.areas < 1);
                }
            }
        },
    }
</script>

<style scoped>
</style>
